import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import SignaturePopup from "../components/SignaturePopup";
import { PdfGenerator } from "../components/PdfGenerator";
import generateFullPDF from "../PDFGenerator/index.js";
import backArrow from "../images/Layer 51.svg";
import AWS from "aws-sdk";
import { Document, Page, pdfjs } from "react-pdf";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import SignatureCanvas from "react-signature-canvas";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import config from "../config/aws-config.js"

import { signIn, fetchAuthSession } from '@aws-amplify/auth';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PoliciesConsentForm = ({
  primaryColor = "#1F3047",
  secondaryColor = "#349AC8",
  textColor = "#181818",
  placeholderColor = "#717171",
  onBack = () => { },
  onSubmit = () => { },
  data,
}) => {
  const [showSignaturePopup, setShowSignaturePopup] = useState(false);
  const [signatureText, setSignatureText] = useState("Patient Signature");
  const [currentPdfUrl, setCurrentPdfUrl] = useState(null);
  const [currentPolicyIndex, setCurrentPolicyIndex] = useState(0);
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [signatureData, setSignatureData] = useState(null);
  const [staffSignatureData, setStaffSignatureData] = useState(null);

  const [pdfFile, setPdfFile] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [signatureImg, setSignatureImg] = useState(null);
  const [signatureFields, setSignatureFields] = useState([
    // {
    //   name: "Client_Signature",
    //   page: 2, // MUST specify page number
    //   x: 50, // X position (from left)
    //   y: 230, // Y position (from top)
    //   width: 200,
    //   height: 50,
    //   label: "Client Signature",
    // },
  ]);
  const [modifiedPdfUrl, setModifiedPdfUrl] = useState(null);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [activeField, setActiveField] = useState(null);
  // const [numPages, setNumPages] = useState(null);
  const [pageDimensions, setPageDimensions] = useState({
    width: 550,
    height: 750,
  });
  const [containerWidth, setContainerWidth] = useState(800);
  const containerRef = useRef(null);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const [registration, setRegistration] = useState(false);

  // Handle container resizing
  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.clientWidth);
      }
    };

    updateWidth();
    const resizeObserver = new ResizeObserver(updateWidth);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  // Calculate dimensions
  const pageWidth = Math.min(800, containerWidth * 0.9);
  const scaleFactor = pageWidth / pageDimensions.width;
  const isTouchDevice = "ontouchstart" in window;
  // Form state
  const [formData, setFormData] = useState({
    ...data,
    consentChecked: false,
    termsChecked: false,
    signatureChecked: false,
    clientSignature: signatureData,
    clientName: `${data.personalContact.firstName} ${data.personalContact.lastName}`,
    staffSignature: staffSignatureData,
    staffName: `${data?.medicalLegal?.staffFirstName} ${data?.medicalLegal?.staffLastName}`,
  });

  // Define your policy content
  const policyContents = {
    "Consent Form": {
      title: "Consent Form",
      content: "This is the full content of our consent form...",
    },
    "Grievance Form": {
      title: "Grievance Form",
      content: "This is the full content of our grievance policy...",
    },
    // Add content for all other policies
  };

  useEffect(() => {
    generatePolicyPdf("Consent Form");
    window.localStorage.setItem("formData", JSON.stringify(formData));
    window.localStorage.setItem("signatureData", signatureData);
    window.localStorage.setItem("staffSignatureData", staffSignatureData);
  }, [signatureData && staffSignatureData]);
  // Add this function to generate policy PDFs
  const generatePolicyPdf = async (policyName) => {
    setIsPdfGenerating(true);
    try {
      const policyContent = policyContents[policyName] || {
        title: policyName,
        content: "Policy content not available",
      };

      const { pdfUrl } = await PdfGenerator(
        formData,
        signatureData,
        staffSignatureData,
        policyContent,
        { preview: true }
      );

      setCurrentPdfUrl(pdfUrl);
    } catch (error) {
      console.error("Error generating policy PDF:", error);
    } finally {
      setIsPdfGenerating(false);
    }
  };

  const handleChangesbmit = async (formData) => {
    // onSubmit(formData);

    setRegistration(true);

    const { base64Pdf, pdfBlob } = await PdfGenerator(
      formData,
      signatureData,
      staffSignatureData
    );

    console.log("pdfBlob", pdfBlob)

    const filename = `FullIntakeForm_${Date.now()}.pdf`;

    // Step 1: Ask backend for pre-signed URL

    let uploadUrl;

    try {
      const res = await fetch(`${process.env.REACT_APP_URL}/generate-presigned-url`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          filename,
          contentType: 'application/pdf',
        }),
      });

      const data = await res.json();
      const body = JSON.parse(data.body);
      console.log("body", body);
      const { putUrl } = body;

      console.log("putUrl", putUrl);
      uploadUrl = putUrl;

    } catch (err) {
      console.error('Error getting pre-signed URL:', err);
      return;
    }

    // Step 2: Upload PDF to S3
    console.log("uploadUrl", uploadUrl)
    let uploadSuccess = false;
    try {
      const response = await fetch(uploadUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/pdf",
        },
        body: pdfBlob,
      });

      if (!response.ok) throw new Error("S3 upload failed");

      console.log("✅ PDF uploaded to S3!");
      uploadSuccess = true;
    } catch (uploadErr) {
      console.error("❌ Error uploading PDF to S3:", uploadErr);
      return;
    }


    // Optional Step 3: Notify url to user
    if (uploadSuccess) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_URL}/upload-pdf`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              fileName: filename,
              email: data?.personalContact?.email,
              formData: formData,
            }),
          }
        );

        if (!response.ok) throw new Error("Failed to upload PDF");

        const result = await response.json();
        console.log("PDF uploaded to S3 and email sent:", result);

        onSubmit(formData);
        setRegistration(false);
      } catch (error) {
        console.error("Error uploading PDF:", error);
      }
    }
  };

  const handleCheckboxChange = (field) => {
    setFormData((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClearSignature = () => {
    console.log("Signature cleared");
  };

  const handleConfirmSignature = (sigData) => {
    console.log("Signature confirmed");
    setShowSignaturePopup(false);
    if (signatureText === "Client Signature") {
      setSignatureData(sigData);
    } else {
      setStaffSignatureData(sigData);
    }
    console.log("signatureData", signatureData);
  };

  const handleStaffSignature = () => {
    console.log("Signature confirmed");
    setSignatureText("Staff Signature");
    setShowSignaturePopup(true);
  };

  const handleClientSignature = () => {
    console.log("Signature confirmed");
    setSignatureText("Client Signature");
    setShowSignaturePopup(true);
  };

  const handleFieldClick = (fieldIndex) => {
    try {
      // Validate field index
      if (fieldIndex < 0 || fieldIndex >= signatureFields.length) {
        console.error("Invalid field index:", fieldIndex);
        return;
      }

      const clickedField = signatureFields[fieldIndex];

      // Check if this field already has a signature
      if (clickedField.signature) {
        // Option 1: Keep existing behavior (do nothing)
        // return;

        // Option 2: Allow signature replacement
        const shouldReplace = window.confirm(
          "This field already has a signature. Replace it?"
        );
        if (!shouldReplace) return;
      }

      // If we have existing signature data, apply it immediately
      if (signatureData) {
        setSignatureFields((prevFields) =>
          prevFields.map((field, index) =>
            index === fieldIndex
              ? {
                ...field,
                signature: signatureData,
                signedAt: new Date().toISOString(), // Add timestamp
              }
              : field
          )
        );

        // Optional: track signature events
        console.log("Signature applied to field:", clickedField.name);
        return;
      }

      // No signature data available - open signature modal
      setActiveField(fieldIndex);
      handleClientSignature();

      // Optional: track which field was clicked
      console.log("Preparing to sign field:", clickedField.name);
    } catch (error) {
      console.error("Error handling field click:", error);
      // Optional: show user feedback
      alert("An error occurred while handling the signature field");
    }
  };

  //   useEffect(() => {
  //   signatureFields.forEach(field => {
  //     console.log(`Field ${field.name} - x:${field.x} y:${field.y}`);
  //   });
  // }, []);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "48px",
        padding: "20px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Main Title */}
      <div
        style={{
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        <h1
          style={{
            alignSelf: "stretch",
            textAlign: "center",
            color: primaryColor,
            fontSize: "32px",
            fontFamily: "Mauren, sans-serif",
            fontWeight: "100",
            margin: 0,
          }}
        >
          Policies & Terms of Consent
        </h1>
        <div style={{ alignSelf: "stretch", textAlign: "center" }}>
          <span
            style={{
              color: primaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            Please review the following policies and acknowledgments required to
            complete your intake.
            <br />
            These ensure mutual understanding of your rights, responsibilities,
            and the care process at <br />
          </span>
          <span
            style={{
              color: secondaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            Legacy Healing Center
          </span>
          <span
            style={{
              color: primaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            .
          </span>
        </div>
      </div>

      {/* Policies List and Document Viewer */}
      <div
        style={{
          alignSelf: "stretch",
          // height: "960px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "flex-start",
          gap: "24px",
        }}
      >
        {/* Document Viewer */}
        <div
          style={{
            flex: "1 1 0",
            alignSelf: "stretch",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "8px",
          }}
        >
          {isPdfGenerating ? (
            <div
              style={{
                alignSelf: "stretch",
                height: "672.94px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: primaryColor,
              }}
            >
              Loading policy document...
            </div>
          ) : currentPdfUrl ? (
            // <iframe
            //   src={currentPdfUrl}
            //   style={{
            //     alignSelf: "stretch",
            //     height: "972.94px",
            //     border: `1px solid ${secondaryColor}`,
            //     borderRadius: "8px",
            //   }}
            //   title="Policy Document Preview"
            // />
            <div
              ref={containerRef}
              style={{
                height: "100vh",
                overflow: "auto",
                width: "100%",
                padding: "20px 0",
                backgroundColor: "#f9f9f9",
                WebkitOverflowScrolling: "touch",
                touchAction: isIOS ? "manipulation" : "auto",
              }}
            >
              <Document
                file={currentPdfUrl}
                onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                loading={<div>Loading PDF...</div>}
              >
                {Array.from({ length: numPages || 0 }).map((_, index) => {
                  const pageNumber = index + 1;
                  return (
                    <div
                      key={`page-${pageNumber}`}
                      style={{
                        position: "relative",
                        margin: "0 auto 30px",
                        width: pageWidth,
                        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                        backgroundColor: "white",
                      }}
                    >
                      <Page
                        pageNumber={pageNumber}
                        width={pageWidth}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        loading={
                          <div
                            style={{
                              width: pageWidth,
                              height:
                                pageWidth *
                                (pageDimensions.height / pageDimensions.width),
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            Loading page {pageNumber}...
                          </div>
                        }
                      />

                      {/* Signature fields with cross-platform styling */}
                      {signatureFields
                        .filter((field) => field.page === pageNumber)
                        .map((field, fieldIndex) => {
                          const fieldStyle = {
                            position: "absolute",
                            left: `${field.x * scaleFactor}px`,
                            top: `${(pageDimensions.height - field.y - field.height) *
                              scaleFactor
                              }px`,
                            width: `${field.width * scaleFactor - 120}px`,
                            height: `${field.height * scaleFactor - 30}px`,
                            border: field.signature
                              ? "2px solid #4CAF50"
                              : "2px dashed #2196F3",
                            backgroundColor: field.signature
                              ? "rgba(76, 175, 80, 0.1)"
                              : "rgba(33, 150, 243, 0.1)",
                            borderRadius: "4px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 10,
                            transition: "all 0.2s ease",
                            boxSizing: "border-box",
                            minWidth: "44px", // Minimum touch target size for iOS
                            minHeight: "44px",
                          };

                          // Enhance touch experience on iPad
                          if (isTouchDevice) {
                            fieldStyle.touchAction = "manipulation";
                            fieldStyle.WebkitTapHighlightColor = "transparent";
                          }

                          return (
                            <div
                              key={`${field.name}-${pageNumber}`}
                              onClick={() => handleFieldClick(fieldIndex)}
                              onTouchStart={(e) => isIOS && e.preventDefault()}
                              style={fieldStyle}
                            >
                              {field.signature ? (
                                <img
                                  src={field.signature}
                                  alt="Signature"
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                    pointerEvents: "none",
                                  }}
                                />
                              ) : (
                                <span
                                  style={{
                                    color: "#2196F3",
                                    fontWeight: "600",
                                    fontSize: `${Math.max(
                                      12,
                                      14 * scaleFactor - 10
                                    )}px`,
                                    textAlign: "center",
                                    padding: "8px",
                                  }}
                                >
                                  {field.label}
                                </span>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
              </Document>
            </div>
          ) : (
            <div
              style={{
                alignSelf: "stretch",
                height: "672.94px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: placeholderColor,
                fontStyle: "italic",
              }}
            >
              Select a policy to preview
            </div>
          )}
        </div>
      </div>

      {/* Consent Checkboxes */}
      <div
        style={{
          alignSelf: "stretch",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: "16px",
        }}
      >
        {/* Checkbox 1 */}
        <div
          style={{
            alignSelf: "stretch",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            onClick={() => handleCheckboxChange("consentChecked")}
            style={{
              width: "24px",
              height: "24px",
              padding: "2px",
              position: "relative",
              overflow: "hidden",
              borderRadius: "4px",
              outline: `1px ${primaryColor} solid`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              backgroundColor: formData.consentChecked
                ? primaryColor
                : "transparent",
            }}
          >
            {formData.consentChecked && (
              <div
                style={{
                  width: "15px",
                  height: "10px",
                  borderBottom: "2px solid white",
                  borderLeft: "2px solid white",
                  transform: "rotate(-45deg)",
                  marginBottom: "2px",
                }}
              />
            )}
          </div>
          <div
            style={{
              textAlign: "center",
              color: primaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            I have reviewed the consent packet above and confirm that the
            information is correct.
          </div>
        </div>

        {/* Checkbox 2 */}
        <div
          style={{
            alignSelf: "stretch",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            onClick={() => handleCheckboxChange("termsChecked")}
            style={{
              width: "24px",
              height: "24px",
              padding: "2px",
              position: "relative",
              overflow: "hidden",
              borderRadius: "4px",
              outline: `1px ${primaryColor} solid`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              backgroundColor: formData.termsChecked
                ? primaryColor
                : "transparent",
            }}
          >
            {formData.termsChecked && (
              <div
                style={{
                  width: "15px",
                  height: "10px",
                  borderBottom: "2px solid white",
                  borderLeft: "2px solid white",
                  transform: "rotate(-45deg)",
                  marginBottom: "2px",
                }}
              />
            )}
          </div>
          <div
            style={{
              textAlign: "center",
              color: primaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            I have read and agree to the terms, policies, and conditions
            outlined in the document.
          </div>
        </div>

        {/* Checkbox 3 */}
        <div
          style={{
            alignSelf: "stretch",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            onClick={() => handleCheckboxChange("signatureChecked")}
            style={{
              width: "24px",
              height: "24px",
              padding: "2px",
              position: "relative",
              overflow: "hidden",
              borderRadius: "4px",
              outline: `1px ${primaryColor} solid`,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              cursor: "pointer",
              backgroundColor: formData.signatureChecked
                ? primaryColor
                : "transparent",
            }}
          >
            {formData.signatureChecked && (
              <div
                style={{
                  width: "15px",
                  height: "10px",
                  borderBottom: "2px solid white",
                  borderLeft: "2px solid white",
                  transform: "rotate(-45deg)",
                  marginBottom: "2px",
                }}
              />
            )}
          </div>
          <div
            style={{
              textAlign: "center",
              color: primaryColor,
              fontSize: "16px",
              fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
              fontWeight: "400",
              lineHeight: "24px",
            }}
          >
            I understand that this signature will serve as my agreement to all
            the listed items.
          </div>
        </div>
      </div>

      {/* Signature Sections */}
      <div
        style={{
          alignSelf: "stretch",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: "24px",
        }}
      >
        {/* Client Signature */}
        <div
          style={{
            flex: "1 1 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                color: textColor,
                fontSize: "12px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              Client Signature
            </div>
            <div
              style={{
                alignSelf: "stretch",
                height: "150px",
                background: "white",
                borderRadius: "8px",
                outline: `1px ${secondaryColor} solid`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => handleClientSignature()}
            >
              {signatureData ? (
                <img
                  src={signatureData}
                  alt="Client Signature"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ) : (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "rgba(112.62, 112.62, 112.62, 0.50)",
                    fontSize: "48px",
                    fontFamily: "Turbinado Pro, sans-serif",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  Client Signature
                </div>
              )}
            </div>
          </div>
          <div
            style={{
              alignSelf: "stretch",
              height: "63px",
              padding: "8px",
              borderRadius: "8px",
              outline: `1px ${primaryColor} solid`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                height: "15px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "4px",
              }}
            >
              <div
                style={{
                  color: textColor,
                  fontSize: "12px",
                  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                  fontWeight: "400",
                }}
              >
                Client Full Name
              </div>
            </div>
            <div
              style={{
                alignSelf: "stretch",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  flex: "1 1 0",
                  color: primaryColor,
                  fontSize: "16px",
                  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                  fontWeight: "400",
                  lineHeight: "24px",
                }}
              >
                {formData.clientName}
              </div>
            </div>
          </div>
        </div>

        {/* Staff Signature */}
        <div
          style={{
            flex: "1 1 0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <div
            style={{
              alignSelf: "stretch",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                color: textColor,
                fontSize: "12px",
                fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                fontWeight: "400",
              }}
            >
              Staff Signature
            </div>
            <div
              style={{
                alignSelf: "stretch",
                height: "150px",
                background: "white",
                borderRadius: "8px",
                outline: `1px ${secondaryColor} solid`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => handleStaffSignature()}
            >
              {staffSignatureData ? (
                <img
                  src={staffSignatureData}
                  alt="Staff Signature"
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                />
              ) : (
                <div
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    flexDirection: "column",
                    color: "rgba(112.62, 112.62, 112.62, 0.50)",
                    fontSize: "48px",
                    fontFamily: "Turbinado Pro, sans-serif",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  Staff Signature
                </div>
              )}
            </div>
            {showSignaturePopup && (
              <SignaturePopup
                clientSignatureText={signatureText}
                onClose={() => setShowSignaturePopup(false)}
                onClear={handleClearSignature}
                onConfirm={handleConfirmSignature}
              />
            )}
          </div>
          <div
            style={{
              alignSelf: "stretch",
              height: "63px",
              padding: "8px",
              borderRadius: "8px",
              outline: `1px ${primaryColor} solid`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              gap: "8px",
            }}
          >
            <div
              style={{
                alignSelf: "stretch",
                height: "15px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "4px",
              }}
            >
              <div
                style={{
                  color: textColor,
                  fontSize: "12px",
                  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                  fontWeight: "400",
                }}
              >
                Staff Full Name
              </div>
            </div>
            <div
              style={{
                alignSelf: "stretch",
                borderRadius: "8px",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "12px",
              }}
            >
              <div
                style={{
                  flex: "1 1 0",
                  color: primaryColor,
                  fontSize: "16px",
                  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                  fontWeight: "400",
                  lineHeight: "24px",
                }}
              >
                {formData.staffName}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Form Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "24px",
          width: "100%",
          marginTop: "20px",
        }}
      >
        {
          registration ? (
            <span
              style={({
                color: "rgb(52, 154, 200)",
              })}
            >
              Uploading the form. Please don’t close the window...
            </span>
          ) : (
            <div

              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "24px",
                width: "100%",
                marginTop: "20px",
              }}
            >

              <button
                onClick={onBack}
                style={{
                  padding: "12px 16px",
                  borderRadius: "16px",
                  outline: `1px solid ${secondaryColor}`,
                  border: "none",
                  background: "transparent",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    width: "24px",
                    height: "24px",
                    padding: "6px",
                    background: secondaryColor,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img src={backArrow} alt="" />
                </div>
                <span
                  style={{
                    color: primaryColor,
                    fontSize: "16px",
                    fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                    fontWeight: "400",
                  }}
                >
                  Belongings & Devices
                </span>
              </button>

              <button
                onClick={() => handleChangesbmit(formData)}
                disabled={
                  !formData.consentChecked ||
                  !formData.termsChecked ||
                  !formData.signatureChecked
                }
                style={{
                  padding: "12px 16px",
                  background: secondaryColor,
                  borderRadius: "16px",
                  border: "none",
                  color: "white",
                  fontSize: "16px",
                  fontFamily: "'FONTSPRING DEMO - Commuters Sans', sans-serif",
                  fontWeight: "400",
                  cursor: "pointer",
                  opacity:
                    !formData.consentChecked ||
                      !formData.termsChecked ||
                      !formData.signatureChecked
                      ? 0.5
                      : 1,
                }}
              >
                Submit Registration
              </button>
            </div>
          )
        }

      </div>
    </div>
  );
};

// PropTypes
PoliciesConsentForm.propTypes = {
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  textColor: PropTypes.string,
  placeholderColor: PropTypes.string,
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default PoliciesConsentForm;
